import { useContext } from 'react';
import { UserContextProps, UserContext } from '../contexts/userContext';

export function useUser(): UserContextProps {
  return useContext(UserContext);
}
